module.exports = __webpack_public_path__ + "img/img4.72639966.png";